import { connect } from 'react-redux';
import { List } from 'immutable';
import LearningAdminModuleSerieForm from '../components/LearningAdminModuleSerieForm';
import storage from '../../../../../lib/Storage';
import { findStorageType } from '../../../../../lib/Auth';

const inputs = List(['title']);

const mapStateToProps = (state, ownProps) => {
  const data = {},
    errors = {};

  for (const val of inputs.values()) {
    data[val] = state.entities.getIn(
      ['learningModuleSeriesAdmin', ownProps.id, val],
      ''
    );
    if (state.learningsAdmin.getIn(['form', 'errors', val])) {
      errors[val] = state.learningsAdmin.getIn(['form', 'errors', val]);
    }
  }

  return {
    isLoading: state.learningsAdmin.get('isLoading'),
    isSubmitting: state.learningsAdmin.getIn(['form', 'isSubmitting']),
    success: state.learningsAdmin.getIn(['form', 'success']),
    data: data,
    errors: errors,
    partnershipId: storage.get(findStorageType(), 'partnershipId'),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

const LearningAdminModuleSerieFormContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(LearningAdminModuleSerieForm);

export default LearningAdminModuleSerieFormContainer;
